import { render, staticRenderFns } from "./dopay.vue?vue&type=template&id=ca99e5a0&scoped=true"
import script from "./dopay.vue?vue&type=script&lang=js"
export * from "./dopay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca99e5a0",
  null
  
)

export default component.exports